<template>
  <div class="ball-container">
    <transition name="fade" v-for="ball in balls" :key="ball" @before-enter="beforeEnter" @enter="enter" @after-enter="afterEnter">
      <div class="ball" v-show="ball.show">
        <div class="inner inner-hook"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import eventBus from './eventBus'
export default {
  name: 'shopCartAnimation',
  props: {
    isFixed: {
      type: Boolean,
      default: false
    },
    distance: {
      type: Object,
      default: {
        top: 0,
        left: 0
      }
    }
  },
  data () {
    return {
      offset: {
        x: 0,
        y: 0
      },
      // 使用balls存放5个小球，这些小球的默认状态都是不显示的
      balls: [{show: false}, {show: false}, {show: false}, {show: false}, {show: false}],
      dropBalls: [] // 用dropBalls来存放掉落的小球,
    }
  },
  methods: {
    drop (el) {
      for (let i = 0; i < this.balls.length; i++) {
        let ball = this.balls[i]
        if (!ball.show) {
          ball.show = true
          ball.el = el // 设置小球的el属性为一个dom对象
          this.dropBalls.push(ball)
          return
        }
      }
    },
    beforeEnter (el) {
      let count = this.balls.length
      while (count--) {
        let ball = this.balls[count]
        let scrollTop = document.documentElement ? document.documentElement.scrollTop : document.body.scrollTop
        let scrollLeft = document.documentElement ? document.documentElement.scrollLeft : document.body.scrollLeft
        if (ball.show) {
          let rect = ball.el.getBoundingClientRect()
          let x = -(this.distance.left - scrollLeft - rect.left - this.offset.x)
          let y = rect.top - (this.distance.top - scrollTop) + this.offset.y
          el.style.display = ''
          el.style.webkitTransform = `translate3d(0,${y}px,0)`
          el.style.transform = `translate3d(0,${y}px,0)`
          el.style.msTransform = `translate3d(0,${y}px,0)`
          // 处理内层动画
          let inner = el.getElementsByClassName('inner-hook')[0] // 使用inner-hook类来单纯被js操作
          inner.style.webkitTransform = `translate3d(${x}px,0,0)`
          inner.style.transform = `translate3d(${x}px,0,0)`
          inner.style.msTransform = `translate3d(${x}px,0,0)`
        }
      }
    },
    enter (el, done) {
      /* eslint-disable no-unused-vars */
      let rf = el.offsetHeight // 触发重绘html
      setTimeout(() => {
        this.$nextTick(() => { // 让动画效果异步执行,提高性能
          el.style.webkitTransform = 'translate3d(0,0,0)'
          el.style.transform = 'translate3d(0,0,0)'
          el.style.msTransform = 'translate3d(0,0,0)'
          // 处理内层动画
          let inner = el.getElementsByClassName('inner-hook')[0] // 使用inner-hook类来单纯被js操作
          inner.style.webkitTransform = 'translate3d(0,0,0)'
          inner.style.transform = 'translate3d(0,0,0)'
          inner.style.msTransform = 'translate3d(0,0,0)'
          if (navigator.appName === 'Microsoft Internet Explorer' && parseInt(navigator.appVersion.split(';')[1].replace(/[ ]/g, '').replace('MSIE', '')) < 10) {
            inner.style.display = 'none'
          }
          el.addEventListener('webkitTransitionEnd', done)
          el.addEventListener('transitionend', done) // Vue为了知道过渡的完成，必须设置相应的事件监听器。
        })
      }, 0)
    },
    afterEnter (el) {
      let ball = this.dropBalls.shift() // 完成一次动画就删除一个dropBalls的小球
      if (ball) {
        ball.show = false
        el.style.display = 'none' // 隐藏小球
      }
    }
  },
  mounted () {
    eventBus.$on('myEvent', (args) => { 
      if (!this.isFixed) {
        this.drop(args)
      }
    })
  }
}
</script>

<style scoped lang="scss">
  .ball-container {
    .ball {
      /*position: fixed;*/
      z-index: 200;
      transition: all 0.55s cubic-bezier(0.49,-0.29,0.75, 0.14); //贝塞尔曲线
      .inner {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background: #F46A5C;
        transition: all 0.55s linear
      }
    }
  }
</style>
